module.exports = __webpack_public_path__ + "img/ejymjpg.c8785841.png";